import { createApp } from 'vue';
import { addClass, removeClass } from '@/utils/index';

const relativeCls = 'relative';

export default function createLikeDirective(Comp) {
  function append(el) {
    const { name } = Comp;
    const style = getComputedStyle(el);
    if (['absolute', 'fixed', 'relative'].indexOf(style.position) === -1) {
      addClass(el, relativeCls);
    }
    el.appendChild(el[name].instance.$el);
  }

  function remove(el) {
    const { name } = Comp;
    removeClass(el, relativeCls);
    el.removeChild(el[name].instance.$el);
  }
  return {
    mounted(el, binding) {
      const app = createApp(Comp);
      const instance = app.mount(document.createElement('div'));
      const { name } = Comp;
      if (!el[name]) {
         
        el[name] = {};
      }
       
      el[name].instance = instance;
      const title = binding.arg;
      if (typeof title !== 'undefined') {
        instance.setTitle(title);
      }

      if (binding.value) {
        append(el);
      }
    },
    updated(el, binding) {
      const title = binding.arg;
      const { name } = Comp;
      if (typeof title !== 'undefined') {
        el[name].instance.setTitle(title);
      }
      if (binding.value !== binding.oldValue) {
        // eslint-disable-next-line no-unused-expressions
        binding.value ? append(el) : remove(el);
      }
    },
  };
}
